import React, { useState } from "react";
import { Map, Download } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { GuidedTour } from "@/components/GuidedTour";
import { useL } from "@/lib/useL";

const IMG = "/SUX1_interface_annotee.png";
const DL = `${process.env.REACT_APP_BACKEND_URL}/api/download/interface-annotee`;

// "Visite guidée": 4-step spotlight tour, with the annotated image as a bonus.
export function InterfaceTour() {
  const L = useL();
  const [tour, setTour] = useState(false);
  const [img, setImg] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setTour(true)}
        data-testid="interface-tour-btn"
        data-tip={L("Visite guidée : 4 étapes pour apprendre à faire votre premier résumé.", "Guided tour: 4 steps to make your first summary.")}
        className="font-mono uppercase tracking-[0.2em] text-[10px] border border-[#002FA7] text-[#002FA7] px-3 py-2 hover:bg-[#002FA7] hover:text-white transition-colors flex items-center gap-2"
      >
        <Map className="w-3 h-3" /> {L("Visite guidée", "Guided tour")}
      </button>
      <GuidedTour open={tour} onClose={() => setTour(false)} onShowImage={() => setImg(true)} />
      <Dialog open={img} onOpenChange={setImg}>
        <DialogContent className="max-w-[min(1400px,95vw)] max-h-[92vh] overflow-auto p-4" data-testid="interface-tour-dialog">
          <DialogTitle className="flex items-center justify-between gap-4 pr-8">
            <span>{L("L'interface en un coup d'œil", "The interface at a glance")}</span>
            <a href={DL} data-testid="interface-tour-download"
              className="font-mono uppercase tracking-[0.2em] text-[10px] bg-[#002FA7] text-white px-3 py-2 hover:bg-[#00227A] transition-colors flex items-center gap-2">
              <Download className="w-3 h-3" /> {L("Télécharger", "Download")}
            </a>
          </DialogTitle>
          <img src={IMG} alt={L("Interface SUX1 annotée avec des flèches explicatives", "SUX1 interface annotated with arrows")} className="w-full h-auto" data-testid="interface-tour-image" />
        </DialogContent>
      </Dialog>
    </>
  );
}

export default InterfaceTour;
